<template>
  <div class="com-container">
    <div class="com-chart" ref="rank_ref"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      chartInstance: null,
      allData: null,
      timerId: null, // 定时器的标识
    };
  },
  mounted() {
    this.initChart();
    this.getData();
    window.addEventListener("resize", this.screenAdapter);
    // 在页面加载完成的时候, 主动进行屏幕的适配
    this.screenAdapter();
  },
  destroyed() {
    clearInterval(this.timerId);
    // 在组件销毁的时候, 需要将监听器取消掉
    window.removeEventListener("resize", this.screenAdapter);
  },
  methods: {
    initChart() {
      this.chartInstance = this.$echarts.init(this.$refs.rank_ref, "chalk");
      const initOption = {
        // 坐标系的位置
        title: {
          text: "近30天日平均产能",
          right: "8%",
          top: 0,
          textStyle: {
            fontSize: 14,
          },
        },
        grid: {
          left: "8%",
          top: "15%",
          right: "8%",
          bottom: "5%",
          containLabel: true, // 距离是包含坐标轴上的文字
        },
        // 提示框组件
        tooltip: {
          show: true,
        },
        xAxis: {
          type: "category",
          axisLabel: {
            color: "#fff",
            interval: 0,
          },
        },
        yAxis: {
          name: "单位/h",
          nameTextStyle: {
            color: "#fff",
          },
          type: "value",
          axisLabel: {
            color: "#fff",
          },
          max: 24,
          interval: 6,
        },
        series: [
          {
            type: "bar",
          },
        ],
      };
      this.chartInstance.setOption(initOption);
      // 对图表对象进行鼠标事件的监听
      this.chartInstance.on("mouseover", () => {
        clearInterval(this.timerId);
      });
      this.chartInstance.on("mouseout", () => {
        this.startInterval();
      });
    },
    async getData() {
      const res = await axios.get(this.$api.regionalCapacityAnalysis);
      let dataList = res.data.data;
      dataList.axisData.forEach((item, index) => {
        if (item == "盐城经济技术开发区") {
          dataList.axisData[index] = "经开区";
        }
      });
      this.allData = res.data.data;
      this.updateChart();
      // 启动定时器
      this.startInterval();
    },
    updateChart() {
      const colorArr = [
        ["#23D6F2", "#033B62"],
        ["#0BA82C", "#4FF778"],
        ["#2E72BF", "#23E5E5"],
        ["#5052EE", "#AB6EE5"],
      ];
      const dataOption = {
        xAxis: {
          data: this.allData.axisData,
        },
        series: [
          {
            data: this.allData.data,
            itemStyle: {
              color: (arg) => {
                let targetColorArr = null;
                targetColorArr = colorArr[2];
                return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  // 百分之0状态之下的颜色值
                  {
                    offset: 0,
                    color: targetColorArr[0],
                  },
                  // 百分之100状态之下的颜色值
                  {
                    offset: 1,
                    color: targetColorArr[1],
                  },
                ]);
              },
            },

            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
          },
        ],
      };
      this.chartInstance.setOption(dataOption);
    },
    // 定时器
    startInterval() {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        this.updateChart();
      }, 2000);
    },
    screenAdapter() {
      const titleFontSize = (this.$refs.rank_ref.offsetWidth / 100) * 3.6;
      const adapterOption = {
        // 标题
        series: [
          {
            barWidth: titleFontSize, // 柱的高度
            itemStyle: {
              // 柱的圆角
              barBorderRadius: [titleFontSize / 2, titleFontSize / 2, 0, 0],
            },
          },
        ],
      };
      this.chartInstance.setOption(adapterOption);
      // 手动的调用图表对象的resize 才能产生效果
      this.chartInstance.resize();
    },
  },
};
</script>

<style>
</style>
